export const URL_ENDPOINTS = {
  BASE_URL: import.meta.env.VITE_BASE_URL,
  MERCHANT: import.meta.env.VITE_URL_API_MERCHANT! + '/merchants',
  COMMERCIAL_OFFER:
    import.meta.env.VITE_URL_API_MERCHANT! + '/commercial-offers',
  FINANCIAL:
    import.meta.env.VITE_URL_API_FINANCIAL! + '/loan-simulations?currency=EUR',
  COUNTRY_LIST: import.meta.env.VITE_URL_API_CONFIG + '/keys?group=PAI',
  ROAD_TYPE_LIST: import.meta.env.VITE_URL_API_CONFIG + '/keys?group=VIA',
  CONTRACT_TYPE: import.meta.env.VITE_URL_API_CONFIG + '/keys?group=A07',
  CITY: import.meta.env.VITE_URL_API_CONFIG + '/cities',
  CREDIT_PROPOSAL:
    import.meta.env.VITE_URL_API_CREDIT_PROPOSAL + '/credit-proposals',
  SIGNATURE: import.meta.env.VITE_URL_API_ESIGNATURE + '/esignatures',
  SECURITY: import.meta.env.VITE_URL_API_SECURITY + '/token',
  OCR: import.meta.env.VITE_URL_API_OCR,
  LOAN: import.meta.env.VITE_URL_API_LOAN + '/loans',
};

export enum ROUTES_PATH {
  LANDING = '/',
  ENTRY = '/entry',
  ENTRY_SUS = '/entrySUS',
  PERSONAL_DATA = '/personal-data',
  LABOR_DATA = '/labor-data',
  OCR = '/documentation',
  // PAYMENT = "/tpv",
  PAYMENT = '/payment',
  BANKREADER = '/bank-process',
  SIGNATURE = '/signature',
  END = '/end',
  TIMEOUT = '/timeout',
  DENIAL = '/denial',
  CANCEL = '/cancel',
  UNKNOWN_ERROR = '/unknown-error',
  UNPROCESSABLE = '/unprocessable',
  QUIT = '/quit',
  OPERATION_SHIPPING = '/operation-shipping',
  OPERATION_SHIPPING_FINISHED = '/operation-shipping-finished',
  CONTINUATION = '/continuation',
  COUNTER_OFFER = '/counter-offer',
  EXISTING_PAYMENT = '/existing-payment-card',
  ERROR_CARD = '/error-card',
  NODATABKR = '/no-data-bankreader',
  EXISTING_RFN = '/existing-refinanced-loan',
  PERSONAL_FINANCES = '/personal-finances',
  PERSONAL_FINANCES_UNAVAILABLE = '/personal-finances-unavailable',
}

export const PAYMENTS_URL = {
  URL_OK: import.meta.env.VITE_ENV_URL + '/#/payment-check?paymentOk',
  URL_KO: import.meta.env.VITE_ENV_URL + '/#/payment-check',
  URL_CANCEL: import.meta.env.VITE_ENV_URL + '/#/payment-check',
};

export const REDIRECT_URL = {
  PEPPER_HELP: 'https://peppermoney.es/ecommerce/clientes/',
  CLAVE_PIN_REGISTRATION:
    import.meta.env.VITE_COMERCIOS_URL + '/alta-clave-pin',
};

export const VALIDATOR_PATTERN = {
  NAME: /^[A-Za-zÁÉÍÓÚñáéíóúÑ\-\s\']+$/, // eslint-disable-line
  SURNAME:
    /^([A-Za-zÁÉÍÓÚñáéíóúÑ\-]{0}?[A-Za-zÁÉÍÓÚñáéíóúÑ\-\']+[\s])+([A-Za-zÁ-ÉÍÓÚñáéíóúÑ\-]{0}?[A-Za-zÁÉÍÓÚñáéíóúÑ\-\'])+[\s]?([A-Za-zÁÉÍÓÚñáéíóúÑ\-]{0}?[A-Za-zÁÉÍÓÚñáéíóúÑ\-\'])?$/, // eslint-disable-line
  PHONE: /^(\+34|0034|34)?[ .-]*(6|7)[ .-]*([0-9][ .-]*){8}$/,
  MOBILE_PHONE: /^[67]\d{8}$/,
  EMAIL: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i,
  DNI: /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i,
  NIE: /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/i,
  DNI_CHARS: 'TRWAGMYFPDXBNJZSQVHLCKE',
  FORBIDDEN_SURNAME_LIST: [
    'DE',
    'DEL',
    'LA',
    'LOS',
    'LAS',
    'Y',
    'SAN',
    'SANTI',
    'SANTO',
    'SANTA',
    'MA',
    'VON',
    'MC',
    'MAC',
  ],
  POSTAL_CODE: /^(?:0[1-9]\d{3}|[1-4]\d{4}|5[0-2]\d{3})$/,
  ONLY_NUMBERS: /^[0-9]*$/,
  DECIMAL_AMOUNT: /^[0-9]+(\.[0-9]+)?$/,
  ENTRY_AMOUNT: /^\d+([.,]\d{1,2})?$/,
};
//Ids de merchant
export const MERCHANTS = {
  DECATHLON: '58070123-ee73-f43f-c763-1b5a23f2c5e8',
};

export const LN_DATA = {
  LN_DOMAIN: import.meta.env.VITE_LN_DOMAIN,
  LN_ORG_ID: import.meta.env.VITE_LN_ORG_ID,
};
